import apiRequest from '@/utils/apiRequest';

export interface FgPublicConfig {
  enabled: boolean;
}

export interface FgGameItem {
  gameId: string;
  name: string;
  iconUrl?: string;
  type: string;
}

export async function getFgConfig(): Promise<FgPublicConfig> {
  return apiRequest<FgPublicConfig>('/public/fg/config', {
    method: 'GET',
  });
}

export async function getFgGameList(): Promise<FgGameItem[]> {
  return apiRequest<FgGameItem[]>('/public/fg/games', {
    method: 'GET',
  });
}

export async function getFgShowLobbyGameList(): Promise<FgGameItem[]> {
  return apiRequest<FgGameItem[]>('/public/fg/showLobby/games', {
    method: 'GET',
  });
}

export async function getGameLink(gameId: string, clientOrigin: string, lang?: string): Promise<string> {
  const response = await apiRequest<{ url: string }>('/fg/getGameLink', {
    method: 'POST',
    data: { gameId, lang, clientOrigin },
  });
  return response.url;
}

// 5G 投注记录
export interface FgTransactionRecord {
  id: string;
  userId: number;
  userAccount: string;
  sn: string;
  type: string;
  gameId: string;
  gameName?: string;
  iconUrl?: string;
  amount: number;
  balanceBefore: number;
  balanceAfter: number;
  createDate: string;
}

interface PageResult<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

export async function getFgTransactions(params?: {
  page?: number;
  pageSize?: number;
}): Promise<PageResult<FgTransactionRecord>> {
  return apiRequest<PageResult<FgTransactionRecord>>('/fg/transactions', {
    method: 'POST',
    data: {
      page: params?.page ?? 0,
      pageSize: params?.pageSize ?? 20,
    },
  });
}

// 5G 注单汇总
export interface FgBetSummaryRecord {
  id: string;
  sn: string;
  gameId: string;
  gameName?: string;
  iconUrl?: string;
  betAmount: number;
  winAmount: number;
  transferAmount: number;
  refunded: boolean;
  transactionCount: number;
  createDate: string;
}

export async function getFgBetSummaries(params?: {
  page?: number;
  pageSize?: number;
}): Promise<PageResult<FgBetSummaryRecord>> {
  return apiRequest<PageResult<FgBetSummaryRecord>>('/fg/betSummaries', {
    method: 'POST',
    data: {
      page: params?.page ?? 0,
      pageSize: params?.pageSize ?? 20,
    },
  });
}

export async function getFgBetSummaryTransactions(sn: string): Promise<FgTransactionRecord[]> {
  return apiRequest<FgTransactionRecord[]>(`/fg/betSummary/transactions?sn=${encodeURIComponent(sn)}`, {
    method: 'POST',
  });
}
